import React, { useEffect } from 'react';
import logo from './logo.svg';
import './App.css';
import Cart from './pages/cart/Cart';
import './assets/cart.css';
import './assets/checkout.css';
import './assets/modal.css';
import './assets/loader.css';
import './pages/checkoutCart/stepper.css'
import { ShoppingCartProvider } from './context/CartContext.tsx/ShoppingCartContext';


import {
  BrowserRouter as Router,
  Route,
  Link,
  Routes,
  Navigate,
  useSearchParams
} from "react-router-dom";
import { Checkout } from './pages/checkoutCart/components/Checkout';
import { Navbar } from './components/Navbar';
import { CheckoutProvider } from './context/checkout/CheckoutContext';
import Stepper from './pages/checkoutCart/components/Stepper';
import Thankyou from './pages/thankyou/Thankyou';
import Navigation from './components/Navigation';
import { SkeletonTheme } from 'react-loading-skeleton';
import AquaCodLoader from './components/AquaCodLoader';
// import { Navigation } from './components/Navigation';


function App() {


  useEffect(() => {
    // Initialize Facebook Pixel
    (window as any).fbq('init', '678089589311638');
    (window as any).fbq('track', 'PageView');
  }, []);
  const shouldRedirectToCheckout = true;
  const shouldRedirectToThankyou = true


  return (
    <SkeletonTheme baseColor="#a3b8c2" highlightColor="#ffffff">
    

    <Router>
      <ShoppingCartProvider>
        <CheckoutProvider>
          <Navbar />
          {/* <Navigation /> */}
          <Routes>
         
            <Route path="/" element={<Cart />}></Route>
            {/* <Cart /> */}
            <Route path="/checkout" element={shouldRedirectToCheckout ? (<Checkout />) : (<Navigate replace to="/" />)}></Route>
            <Route path="/thankyou" element={shouldRedirectToThankyou ? (<Thankyou />) : (<Navigate replace to="/" />)}></Route>
          </Routes>
        </CheckoutProvider>
      </ShoppingCartProvider>
    </Router>
    </SkeletonTheme>
  );
}

export default App;
